"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const HBIcon_1 = __importDefault(require("../components/HBIcon/HBIcon"));
function ThumbsDownThin12Svg(props) {
    return react_1.default.createElement("svg", Object.assign({ width: 12, height: 12, viewBox: "0 0 12 12", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
        react_1.default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2.29606 8.25C0.828306 8.25 -0.246471 6.86737 0.115595 5.44497L0.926324 2.25996C1.26472 0.93053 2.46179 -1.19929e-07 3.83362 0L12.0016 7.14067e-07L12.0016 7.5H9.00159L7.758 11.2308C7.60487 11.6901 7.17497 12 6.69073 12H6.65218C5.29128 12 4.19109 10.9703 4.04371 9.67573C4.02291 9.49298 4.02109 9.30496 4.04021 9.1138L4.11834 8.33246C4.12276 8.28831 4.08808 8.25 4.04371 8.25H2.29606ZM7.50159 7.25658L7.50159 1.5L3.83362 1.5C3.1477 1.5 2.54917 1.96527 2.37997 2.62998L1.56924 5.81499C1.44855 6.28912 1.80681 6.75 2.29606 6.75H4.04371C4.97552 6.75 5.70361 7.55454 5.6109 8.48172L5.53276 9.26306C5.47419 9.84877 5.8742 10.366 6.42788 10.4777L7.50159 7.25658ZM9.00159 6H10.5016L10.5016 1.5H9.00159L9.00159 6Z", fill: "#131416" }));
}
function ThumbsDownThin12(_a) {
    var { svgProps } = _a, props = __rest(_a, ["svgProps"]);
    return react_1.default.createElement(HBIcon_1.default, Object.assign({}, props),
        react_1.default.createElement(ThumbsDownThin12Svg, Object.assign({}, svgProps)));
}
exports.default = ThumbsDownThin12;
//# sourceMappingURL=ThumbsDownThin12.js.map